import styled from 'styled-components'
import Cleave from 'cleave.js/react'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  gap: 10px;
  margin-bottom: 15px;
  flex-direction: row;
  align-items: flex-start;
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  padding: 0px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
  width: 480px;
  background-color: transparent;
  border-radius: 15px;
`

export const Title = styled.h2`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 15px;
  align-self: center;
`;

export const SubTitle = styled(Title)`
  font-size: 16px;
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  color: #FFFFFF;
  margin: 0px;
`

export const Label = styled(InfoText)`
  margin-bottom: 5px;
  color: #000000;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin: 15px 0px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`
